var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccessibilityBraille = function SvgAccessibilityBraille(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 30 30"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.999 23.554V13.096a1.58 1.58 0 0 1 1.576-1.57 1.58 1.58 0 0 1 1.577 1.576v7.552"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13.152 20.04v-.61a1.58 1.58 0 0 1 1.576-1.576 1.58 1.58 0 0 1 1.577 1.577v1.152m0 1.887v-1.703a1.58 1.58 0 0 1 1.576-1.577 1.58 1.58 0 0 1 1.577 1.577v2.765m0-.541v-1.045a1.58 1.58 0 0 1 1.576-1.576c.87 0 1.577.709 1.577 1.685v4.24c0 1.088-.435 2.141-1.14 3.052"
  }), /*#__PURE__*/React.createElement("g", {
    vectorEffect: "non-scaling-stroke",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 11.594,
    cy: 8.009,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M16.742 6.009a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm0 5.102a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
  }), /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 11.594,
    cy: 2.764,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 11.594,
    cy: 2.764,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M16.742.764a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
  })), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.868 29.346a8.6 8.6 0 0 1-1.059-1.751l-.051-.116c-.386-.892-.369-1.756-.369-2.706v-3.385a1.58 1.58 0 0 1 1.577-1.577c.241 0 .48.056.696.163"
  }))));
};
export default SvgAccessibilityBraille;